import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Box, Chip } from '@mui/material';
import { MdArrowBackIosNew } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import * as Yup from "yup";
import HeroImg from '../../Shared components/HeroImg';
import { FormControl, Input, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent } from '@mui/material';
import { Governorate, governorates } from '../../Data/governorates';
import { cities, City } from '../../Data/cites';
import useTraineeStore from '../../context/TrainerContexts';
import usePersonStore from '../../context/RegisterContext';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { Config } from '../../API/config';
import { Trainer } from '../../types/user';
import BeatLoader from 'react-spinners/esm/BeatLoader';
import { Category, SubCategory } from '../../types/categoreies';

interface TrainerData {
    experienceYears: number | undefined;
    age: number | undefined;
    needs: string;
    category: string | undefined;
    subCategory: string | undefined;
    priceOfLesson: number | undefined;
    numberOfLessonsOnWeek: number | undefined;
    notice: string;
    type: string;
}

const TrainerRegister = () => {
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [Loading, setLoading] = React.useState<boolean>(false);
    const [selectedGovernorates, setSelectedGovernorates] = React.useState<Governorate[]>([]);
    const [selectedCities, setSelectedCities] = React.useState<City[]>([]);
    const [selectedCategory, setSelectedCategory] = React.useState<Category>();
    const [selectedSubCategory, setSelectedSubCategory] = React.useState<SubCategory>()
    const [filteredCities, setFilteredCities] = React.useState<City[]>([]);
    const [categories, setCategories] = React.useState<Category[]>([]);
    const [subCategories, setSubCategories] = React.useState<SubCategory[]>([]);
    const trainee = useTraineeStore((state) => state.getTrainee);
    const updateTrainee = useTraineeStore((state) => state.setTrainee);
    const image = usePersonStore((state) => state.getImg);
    const [selectedType, setSelectedType] = React.useState("online")

    const navigate = useNavigate();
    const validationSchema = Yup.object({
        experienceYears: Yup.number().max(100).min(0).required("يجب ادخال سنوات الخبرة"),
        age: Yup.number().max(100).min(0).required("يجب ادخال السن"),
        needs: Yup.string().max(100).required(),
        priceOfLesson: Yup.number().min(0).required(),
        numberOfLessonsOnWeek: Yup.number().min(0).required(),
        notice: Yup.string().required()
    });
    const fetchCategories = async () => {
        try {
            let { data } = await axios.get(Config.getAllRegisterCategory)

            if (data.statusCode == 200) {

                setIsLoading(false)
                setCategories(data.data)
                if (!selectedCategory) {
                    setSelectedCategory(data.data[0])
                    setSubCategories(data.data[0].subCategories || []);
                    setSelectedSubCategory(data.data[0].subCategories[0])
                }
            }
        } catch (err) {
            toast.error("تاكد من اتصالك بالشبكة")
        }
        finally {
            setIsLoading(false)
        }
    }
    React.useEffect(() => {
        fetchCategories();
        UpdateCities();
    }, [selectedGovernorates, selectedCities]);

    const setDefault = () => {

    }
    React.useEffect(() => {
        updateSubCategory();
    }, [selectedCategory]);

    let handleGovernorateChange = async (e: SelectChangeEvent<typeof governorates>) => {
        const selectedValue = e.target.value[selectedGovernorates.length];
        const gov = governorates.find(governorate => governorate.governorate_name_ar === selectedValue);
        const removeGov = selectedGovernorates.findIndex(governorate => governorate.governorate_name_ar === selectedValue);

        if (removeGov !== -1) {
            const newSelectedGovernorates = selectedGovernorates.filter((_, index) => index !== removeGov);
            setSelectedGovernorates(newSelectedGovernorates);
            if (gov?.id) RemoveCities(gov.id);
        } else if (gov) {
            setSelectedGovernorates([...selectedGovernorates, gov]);
            UpdateCities();
        }
    };
    let handleCategoryChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const cat = categories.find(cate => cate.name === e.target.value)
        if (cat) {
            setSelectedCategory(cat)
            updateSubCategory()
        }
    };
    let updateSubCategory = async () => {
        if (selectedCategory) {
            setSubCategories(selectedCategory.subCategories)
            setSelectedSubCategory(selectedCategory.subCategories[0])
        }
    };

    let handleSubCategoryChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const subCat = subCategories.find(sub => sub.name === e.target.value)
        if (subCat) {
            setSelectedSubCategory(subCat)
        }
    };


    let handleCityChange = async (e: SelectChangeEvent<typeof cities>) => {
        const selectedValue = e.target.value[selectedCities.length];
        const city = filteredCities.find(city => city.city_name_ar === selectedValue);
        const removeCity = selectedCities.findIndex(city => city.city_name_ar === selectedValue);

        if (removeCity !== -1) {
            const newSelectedCities = selectedCities.filter((_, index) => index !== removeCity);
            setSelectedCities(newSelectedCities);
        } else if (city) {
            setSelectedCities([...selectedCities, city]);
        }
    };

    function UpdateCities() {
        const filCities: City[] = [];
        cities.forEach(city => {
            if (selectedGovernorates.some(gov => gov.id === city.governorate_id)) {
                filCities.push(city);
            }
        });
        setFilteredCities(filCities);
    }

    function RemoveCities(id: string) {
        setFilteredCities(filteredCities.filter(city => city.governorate_id !== id));
        setSelectedCities(selectedCities.filter(city => city.governorate_id !== id));
    }

    let formik = useFormik({
        initialValues: {
            experienceYears: undefined,
            age: undefined,
            needs: "",
            priceOfLesson: undefined,
            numberOfLessonsOnWeek: undefined,
            notice: "",
            category: selectedCategory?.name,
            subCategory: selectedSubCategory?.name,
            type: selectedType
        },
        validationSchema,
        onSubmit: sendData,
    });

    async function sendData(values: TrainerData) {
        try {

            setLoading(true);

            const missingFields = [];
            if (!image()) missingFields.push("الصورة الشخصية");
            if (!trainee().name) missingFields.push("الاسم");
            if (!trainee().email) missingFields.push("البريد الإلكتروني");
            if (!trainee().phone) missingFields.push("رقم الهاتف");
            if (!trainee().gender) missingFields.push("الجنس");
            if (!trainee().governorate) missingFields.push("المحافظة");
            if (!trainee().city) missingFields.push("المدينة");
            if (!trainee().password) missingFields.push("كلمة المرور");

            if (values.experienceYears === undefined || values.experienceYears < 0) missingFields.push("سنوات الخبرة");
            if (values.age === undefined || values.age <= 0) missingFields.push("العمر");
            if (!values.needs) missingFields.push("الاحتياجات");
            if (!selectedCategory) missingFields.push("الفئة");
            // if (!selectedSubCategory) missingFields.push("الفئة الفرعية");
            if (values.priceOfLesson === undefined || values.priceOfLesson < 0) missingFields.push("سعر الجلسة");
            if (values.numberOfLessonsOnWeek === undefined || values.numberOfLessonsOnWeek <= 0) missingFields.push("عدد الجلسات الأسبوعية");
            if (!values.notice) missingFields.push("الملاحظات");

            if (missingFields.length > 0) {
                toast.error(`الحقول التالية مطلوبة: ${missingFields.join(", ")}`);
                return;
            }

            const formData = new FormData();
            const profileImage = image();


            if (profileImage) {
                formData.append("profileImage", profileImage);
            }

            formData.append("name", trainee().name);
            formData.append("email", trainee().email);
            formData.append("password", trainee().password);
            formData.append("phone", trainee().phone);
            formData.append("gender", trainee().gender || "male");
            formData.append("governorate", trainee().governorate);
            formData.append("city", trainee().city);
            formData.append("yearsOfExperience", String(values.experienceYears || 0));
            formData.append("age", String(values.age || 0));
            formData.append("priceOfLesson", String(values.priceOfLesson || 0));
            formData.append("numberOfLessonsOnWeek", String(values.numberOfLessonsOnWeek || 0));
            formData.append("category", String(selectedCategory?.name));
            formData.append("subCategory", String(selectedSubCategory?.name));
            formData.append("needs", values.needs);
            formData.append("notice", values.notice);
            formData.append("type", values.type);

            selectedGovernorates.forEach(gov => {
                formData.append("serviceGovernorates[]", gov.governorate_name_ar);
            });

            selectedCities.forEach(city => {
                formData.append("serviceCities[]", city.city_name_ar);
            });



            const { data } = await axios.post(
                Config.TrainerRegister,
                formData,
                {
                    withCredentials: true,
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );


            if (data.statusCode === 201) {
                toast.success("تم تسجيل طلبك");
                navigate('/congrats');
            }
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {

                toast.error(error.response.data.message);
            } else {

            }
        } finally {
            setLoading(false);
        }
    }


    return (
        <>
            <Toaster />
            <div className="flex flex-row min-h-screen w-full">
                <HeroImg />
                <div className="flex flex-col items-end justify-start w-full mt-10 px-24 relative">
                    <button onClick={() => navigate(`/register/trainer`)}>
                        <div className='w-[40px] h-[40px] border absolute top-0 left-0 cursor-pointer ml-6 border-neutral-800 rounded-full flex justify-center items-center hover:bg-primary-100 transition-all duration-150 group'>
                            <MdArrowBackIosNew
                                size={22}
                                color='#4a4a4a'
                                fontWeight={200}
                                className="text-neutral-900 group-hover:translate-x-[-2px] group-hover:fill-white transition-transform duration-150"
                            />
                        </div>
                    </button>
                    <div>
                        <div className="w-full flex justify-end">
                            <h2 className="text-[32px] leading-[67.58px] font-[500] text-neutral-900 flex flex-col md:flex-row-reverse items-end">  مرحباً بكم في <div className='mr-2'>Otlob Coach</div></h2>
                        </div>
                        <div className="w-full flex justify-end">
                            <p className="text-[16px] leading-[24px] font-[400] text-neutral-900">هل لديك حساب بالفعل؟<span className="underline mr-1"> <a href="/login">تسجيل الدخول</a></span></p>
                        </div>
                    </div>
                    <div className='w-full my-3 '>
                        <form onSubmit={formik.handleSubmit}>
                            <div className="grid md:grid-cols-4 gap-8">
                                <div className='md:order-3'>
                                    <div className='w-full my-5'>
                                        <label htmlFor="experienceYears" className="block mb-2 text-sm font-medium text-neutral-600 text-right">عدد سنوات الخبرة</label>
                                        <input
                                            onChange={formik.handleChange}
                                            value={formik.values.experienceYears}
                                            onBlur={formik.handleBlur}
                                            type="number"
                                            id="experienceYears"
                                            className="text-right border border-gray-300 text-neutral-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-4"
                                            required
                                        />
                                        {formik.errors.experienceYears && formik.touched.experienceYears ? (
                                            <div className="text-red-500">{formik.errors.experienceYears}</div>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                                <div className='md:order-2'>
                                    <div className='w-full my-5'>
                                        <label htmlFor="age" className="block mb-2 text-sm font-medium text-neutral-600 text-right">السن</label>
                                        <input
                                            onChange={formik.handleChange}
                                            value={formik.values.age}
                                            onBlur={formik.handleBlur}
                                            type="number"
                                            id="age"
                                            className="text-right border border-gray-300 text-neutral-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-4"
                                            required
                                        />
                                        {formik.errors.age && formik.touched.age ? (
                                            <div className="text-red-500">{formik.errors.age}</div>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                                <div className='md:order-1 md:col-span-2'>
                                    <div className='w-full my-5'>
                                        <label htmlFor="needs" className="block mb-2 text-sm font-medium text-neutral-600 text-right">متطلبات الكورس</label>
                                        <input
                                            onChange={formik.handleChange}
                                            value={formik.values.needs}
                                            onBlur={formik.handleBlur}
                                            type="text"
                                            id="needs"
                                            className="text-right border border-gray-300 text-neutral-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-4"
                                            required
                                        />
                                        {formik.errors.needs && formik.touched.needs ? (
                                            <div className="text-red-500">{formik.errors.needs}</div>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="grid md:grid-cols-2 gap-8">
                                <div className='md:order-2'>
                                    <div className='w-full my-5'>
                                        <label htmlFor="priceOfLesson" className="block mb-2 text-sm font-medium text-neutral-600 text-right">سعر الحصة</label>
                                        <input
                                            onChange={formik.handleChange}
                                            value={formik.values.priceOfLesson}
                                            onBlur={formik.handleBlur}
                                            type="number"
                                            id="priceOfLesson"
                                            className="text-right border border-gray-300 text-neutral-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-4"
                                            required
                                        />
                                        {formik.errors.priceOfLesson && formik.touched.priceOfLesson ? (
                                            <div className="text-red-500">{formik.errors.priceOfLesson}</div>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                                <div className='md:order-1'>
                                    <div className='w-full my-5'>
                                        <label htmlFor="numberOfLessonsOnWeek" className="block mb-2 text-sm font-medium text-neutral-600 text-right">عدد الحصص الاسبوعية</label>
                                        <input
                                            onChange={formik.handleChange}
                                            value={formik.values.numberOfLessonsOnWeek}
                                            onBlur={formik.handleBlur}
                                            type="number"
                                            id="numberOfLessonsOnWeek"
                                            className="text-right border border-gray-300 text-neutral-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-4"
                                            required
                                        />
                                        {formik.errors.numberOfLessonsOnWeek && formik.touched.numberOfLessonsOnWeek ? (
                                            <div className="text-red-500">{formik.errors.numberOfLessonsOnWeek}</div>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="grid md:grid-cols-3 gap-8">
                                <div className='md:order-2'>
                                    <div className='w-full my-5'>
                                        <label htmlFor="categories" className="block mb-2 text-sm font-medium text-neutral-600 text-right">الفئة</label>
                                        <select id="categories"
                                            onBlur={formik.handleBlur}
                                            className="text-right border border-gray-300 text-black text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-3"
                                            onChange={handleCategoryChange}>
                                            {categories.map((cat) => {
                                                return <option key={cat._id} value={cat.name}>{cat.name}</option>
                                            })}
                                        </select>
                                        {formik.errors.category && formik.touched.category ? (
                                            <div className="text-red-100">{formik.errors.category}</div>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                                <div className='md:order-1'>
                                    <div className='w-full my-5'>
                                        <label htmlFor="subCategory" className="block mb-2 text-sm font-medium text-neutral-600 text-right">الفئة الفرعية</label>
                                        <select id="subCategory"
                                            value={selectedSubCategory?.name || ""}
                                            onChange={handleSubCategoryChange}
                                            onBlur={formik.handleBlur}
                                            className="text-right border border-gray-300 text-text-black text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-3">
                                            {subCategories ?
                                                subCategories.map((subCat) => {
                                                    return <option key={subCat._id} value={subCat.name}>{subCat.name}</option>
                                                }) :
                                                <option value=''>اختر الفئة اولا</option>}
                                        </select>
                                        {formik.errors.subCategory && formik.touched.subCategory ? (
                                            <div className="text-red-100">{formik.errors.subCategory}</div>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                                <div className='md:order-3'>
                                    <div className='w-full my-5'>
                                        <label htmlFor="type" className="block mb-2 text-sm font-medium text-neutral-600 text-right">التواجد</label>
                                        <select id="type"
                                            onChange={formik.handleChange}
                                            value={formik.values.type}
                                            onBlur={formik.handleBlur} className="text-right border border-gray-300 text-black text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-3">
                                            <option value={"online"}>اونلاين</option>
                                            <option value={"offline"}>اوفلاين</option>
                                            <option value={"both"}>كلاهما</option>
                                        </select>
                                        {formik.errors.type && formik.touched.type ? (
                                            <div className="text-red-100">{formik.errors.age}</div>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="grid md:grid-cols-2 gap-8">
                                <div className='md:order-2'>
                                    <FormControl sx={{ m: 1, width: '100%' }}>
                                        <label
                                            htmlFor="TrainerGov"
                                            className="block mb-2 text-sm font-medium text-neutral-600 text-right"
                                        >
                                            محافظات تقديم الخدمة
                                        </label>
                                        <Select
                                            labelId="TrainerGov"
                                            id="TrainerGov"
                                            multiple
                                            value={selectedGovernorates}
                                            onChange={handleGovernorateChange}
                                            input={<OutlinedInput id="select-multiple-chip" />}
                                            renderValue={(selected) => (
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        gap: 0.5,
                                                        padding: '5px',
                                                    }}
                                                >
                                                    {selected.map((value) => (
                                                        <Chip
                                                            key={value.id}
                                                            label={value.governorate_name_ar}
                                                            sx={{
                                                                backgroundColor: '#2f5b2c',
                                                                color: 'white',
                                                                fontSize: '14px',
                                                                borderRadius: '10px',
                                                            }}
                                                        />
                                                    ))}
                                                </Box>
                                            )}
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        maxHeight: 250,
                                                        borderRadius: '10px',
                                                        boxShadow: 3,
                                                        backgroundColor: 'white',
                                                    },
                                                },
                                            }}
                                            sx={{
                                                textAlign: 'right',
                                                borderRadius: '8px',
                                                backgroundColor: '#fff',
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '10px',
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: 'transparent',
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: 'transparent',
                                                    },
                                                },
                                                '& .MuiChip-root': {
                                                    backgroundColor: '#2f5b2c',
                                                    color: 'white',
                                                },
                                            }}
                                        >
                                            {governorates.map((governorate) => (
                                                <MenuItem
                                                    key={governorate.id}
                                                    value={governorate.governorate_name_ar}
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'right',
                                                        fontSize: '14px',
                                                        color: 'black',
                                                        '&.Mui-selected': {
                                                            backgroundColor: '#1976d2',
                                                            color: 'white',
                                                        },
                                                        '&:hover': {
                                                            backgroundColor: 'inherit',
                                                        },
                                                    }}
                                                >
                                                    {governorate.governorate_name_ar}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className='md:order-1'>
                                    <FormControl sx={{ m: 1, width: '100%' }}>
                                        <label
                                            htmlFor="TrainerCities"
                                            className="block mb-2 text-sm font-medium text-neutral-600 text-right"
                                        >
                                            مناطق تقديم الخدمة
                                        </label>
                                        <Select
                                            labelId="TrainerCities"
                                            id="TrainerCities"
                                            multiple
                                            value={selectedCities}
                                            onChange={handleCityChange}
                                            input={<OutlinedInput id="select-multiple-chip" />}
                                            renderValue={(selected) => (
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        gap: 0.5,
                                                        padding: '5px',
                                                    }}
                                                >
                                                    {selected.map((value) => (
                                                        <Chip
                                                            key={value.id}
                                                            label={value.city_name_ar}
                                                            sx={{
                                                                backgroundColor: '#2f5b2c',
                                                                color: 'white',
                                                                fontSize: '14px',
                                                                borderRadius: '10px',
                                                            }}
                                                        />
                                                    ))}
                                                </Box>
                                            )}
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        maxHeight: 250,
                                                        borderRadius: '10px',
                                                        boxShadow: 3,
                                                        backgroundColor: 'white',
                                                    },
                                                },
                                            }}
                                            sx={{
                                                textAlign: 'right',
                                                borderRadius: '8px',
                                                backgroundColor: '#fff',
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '10px',
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: 'inherit',
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: 'inherit',
                                                    },
                                                },
                                                '& .MuiChip-root': {
                                                    backgroundColor: '#2f5b2c',
                                                    color: 'white',
                                                },
                                            }}
                                        >
                                            {filteredCities.map((city) => (
                                                <MenuItem
                                                    key={city.id}
                                                    value={city.city_name_ar}
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'right',
                                                        fontSize: '14px',
                                                        color: 'black',
                                                        '&.Mui-selected': {
                                                            backgroundColor: '#1976d2',
                                                            color: 'white',
                                                        },
                                                        '&:hover': {
                                                            backgroundColor: 'inherit',
                                                        },
                                                    }}
                                                >
                                                    {city.city_name_ar}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                            <div className="grid md:grid-cols-1 gap-8">
                                <div className='md:order-1'>
                                    <div className='w-full my-5'>
                                        <label htmlFor="notice" className="block mb-2 text-sm font-medium text-neutral-600 text-right">رسالتك التسويقية للمتدربين</label>
                                        <textarea
                                            onChange={formik.handleChange}
                                            value={formik.values.notice}
                                            onBlur={formik.handleBlur}
                                            id="notice"
                                            className="text-right border border-gray-300 text-neutral-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-4"
                                            rows={4}
                                            style={{ resize: 'none' }}
                                        ></textarea>
                                        {formik.errors.notice && formik.touched.notice ? (
                                            <div className="text-red-500">{formik.errors.notice}</div>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='w-full my-5 flex justify-end '>
                                {
                                    Loading ?
                                        <BeatLoader className="mt-5" color="#072605" />
                                        :
                                        <button
                                            type='submit'
                                            disabled={Loading}
                                            className="bg-white text-primary-500 p-2 w-full mt-5 border rounded-md border-primary-500 md:w-[158px] hover:bg-primary-500 hover:text-white hover:border-transparent transition-all duration-500"
                                        >
                                            طلب انشاء حساب
                                        </button>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TrainerRegister;